import { BlogPostType, BlogTagType } from '../model/types/blog';

export const getBlogPostTags = (post: BlogPostType): BlogTagType[] => {
  if (post.blogPostTags?.length) {
    return post.blogPostTags.reduce<BlogTagType[]>((acc, postTag) => {
      const tag = 'tag' in postTag ? postTag.tag : postTag;

      return tag ? [...acc, tag] : acc;
    }, []);
  }

  return post.tags || [];
};

export const getBlogPostFirstTag = (post: BlogPostType): BlogTagType | undefined => getBlogPostTags(post)[0];
